import * as yup from "yup";
import { FormValidationModel } from "../../models/validation";

export interface GradeData {
    categories: GradingCategoryData[];
    comment: string | null;
    commentRequiredText: string;
    placementId: number | null;
    placementIsReject: boolean;
    placementIsRequired: boolean;
}

export class Grade implements FormValidationModel<GradeData> {
    public data: GradeData;
    public rules: yup.Schema<GradeData>;

    public constructor() {
        this.data = {
            categories: [],
            comment: "",
            commentRequiredText: "* Required",
            placementId: null,
            placementIsReject: false,
            placementIsRequired: false,
        };
        this.rules = yup.object<GradeData>().shape({
            categories: yup.array().of(GradingCategorySchema).label("Categories"),
            comment: yup.string().nullable(true).label("Comment").when(["placementIsReject", "commentRequiredText"],
                (placementIsReject: boolean, commentRequiredText: string) => {
                    const schema = yup.string().nullable(true).label("Comment");
                    return placementIsReject
                        ? schema.required(commentRequiredText)
                        : schema;
                }),
            commentRequiredText: yup.string(),
            placementId: yup.number().nullable(true).label("Placement").when(["placementIsRequired"], (placementIsRequired: boolean) => {
                const schema = yup.number().nullable(true).label("Placement");
                return placementIsRequired
                    ? schema.required()
                    : schema;
            }),
            placementIsReject: yup.bool(),
            placementIsRequired: yup.bool(),
        });
    }
}

export interface GradingCategoryData {
    categoryId: number;
    grade: number | null;
    name: string;
    placementIsAbstain: boolean;
}

export const GradingCategorySchema = yup.object<GradingCategoryData>().shape({
    categoryId: yup.number(),
    grade: yup.number().nullable(true).label("Grade").when(["name", "placementIsAbstain"], (name: string, placementIsAbstain: boolean) => {
        const schema = yup.number().nullable(true).label("Grade");
        return placementIsAbstain
            ? schema
            : schema.required(`${name} is required`);
    }),
    name: yup.string(),
    placementIsAbstain: yup.bool(),
});



// WEBPACK FOOTER //
// ./src/forms/abstract/Grade.ts